import Vue from 'vue';
import config from '../../config/config.json';
import { ASSETS_MWC_ROUTES } from '@/constants/routes';
import NotificationService from '../../helpers/notification';

class AssetsMwcApiService {
  constructor() {}

  async getAssetsMwc() {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${ASSETS_MWC_ROUTES.BASE_URL}`
    );

    Vue.localStorage.set('assetsMwc', response.data);
  }

  async createAssetsMwc(assetsMwc) {
    const response = await Vue.prototype.$http
      .post(`${config.apiUrl}${ASSETS_MWC_ROUTES.BASE_URL}`, assetsMwc)
      .catch(error => NotificationService.error(error.message));

    if (!!response) {
      NotificationService.success('MWC image has been saved.');
    }
  }

  async publishMwc() {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${ASSETS_MWC_ROUTES.BASE_URL}/Publish`
    );

    if (response.data) {
      NotificationService.success('MWC has been published.')
    }

    return response.data;
  }
}

export default new AssetsMwcApiService();
